import { defineStore } from 'pinia'

export const ZN_Filters = defineStore({
    id: 'zn_filters_store',
    state: () => {
        return {
            filters: null
        }
    },
    actions: {
        get() {
            return this.filters
        },
        set(data) {
            this.filters = data
        }
    }
})

export const ZN_FiltersFrom1C = defineStore({
    id: 'zn_filters_1C',
    state: () => {
        return {
            filters: null
        }
    },
    actions: {
        get() {
            return this.filters
        },
        set(data) {
            this.filters = data
        }
    }
})
